import "../constants.js";
import { useUsersAndGroups } from "../hooks/useUsersAndGroups.js";
import "react";
import { Skeleton } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
// src/modules/Users/shared/UserAndGroupNames.tsx
function UserAndGroupNames({ max, usersAndGroups }) {
	let maxedUsersOrGroups = usersAndGroups;
	if (max) maxedUsersOrGroups = usersAndGroups.slice(0, max);
	return /* @__PURE__ */ jsxs("span", { children: [maxedUsersOrGroups.map((userOrGroup, i) => /* @__PURE__ */ jsxs("span", { children: [userOrGroup.label, i + 2 <= maxedUsersOrGroups.length && ", "] }, userOrGroup.id)), max && usersAndGroups.length > max && /* @__PURE__ */ jsxs("span", { children: [
		" and ",
		usersAndGroups.length - max,
		" more"
	] })] });
}
function UserAndGroupsFromIds({ max, userAndGroupIds }) {
	let ids = userAndGroupIds;
	if (max) ids = userAndGroupIds.slice(0, max);
	const { data, loading } = useUsersAndGroups(userAndGroupIds?.length > 0 && { idFilter: ids }, { cacheStrategy: "cache-only" });
	if (!data?.usersAndGroups && loading) return /* @__PURE__ */ jsx(Skeleton.Text, {
		chars: 12,
		inline: true,
		lines: userAndGroupIds.length
	});
	if (!userAndGroupIds?.length || !data?.usersAndGroups) return null;
	if (userAndGroupIds.includes("usr-")) return /* @__PURE__ */ jsx("span", { children: "All Users" });
	return /* @__PURE__ */ jsx(UserAndGroupNames, {
		max,
		usersAndGroups: data.usersAndGroups
	});
}
function UsersAndGroups({ max, userAndGroupIds, usersAndGroups }) {
	if (Array.isArray(usersAndGroups) && usersAndGroups.length) return /* @__PURE__ */ jsx(UserAndGroupNames, {
		max,
		usersAndGroups
	});
	if (Array.isArray(userAndGroupIds) && userAndGroupIds.length) return /* @__PURE__ */ jsx(UserAndGroupsFromIds, {
		max,
		userAndGroupIds
	});
	return null;
}
export { UsersAndGroups as UserAndGroupNames };

//# sourceMappingURL=UserAndGroupNames.js.map